import { IconsName } from '@/interfaces';
import { cva, VariantProps } from 'class-variance-authority';
import { FC } from 'react';
import * as SvgIcons from './Icons/index';
export const icon = cva('icon bg-transparent bg-opacity-0 border-0', {
  variants: {
    intent: {
      primary: ['text-primary'],
      secondary: ['text-secondary'],
      accent: ['text-accent'],
      success: ['text-accent/80'],
      ai: ['text-ai/80'],
      error: ['text-error'],
      disabled: ['text-disabled'],
      warning: ['text-warning'],
      transparent: ['text-primary'],
      loading: ['text-primary'],
    },
    size: {
      '2xs': ['w-2xs', 'h-2xs'],
      xs: ['w-xs', 'h-xs'],
      sm: ['w-sm', 'h-sm'],
      md: ['w-md', 'h-md'],
      lg: ['w-lg', 'h-lg'],
      xl: ['w-xl', 'h-xl'],
      '2xl': ['w-2xl', 'h-2xl'],
    },
  },
  defaultVariants: {
    intent: 'primary',
    size: 'md',
  },
});
export const iconWithoutSize = cva(
  'icon bg-transparent bg-opacity-0 border-0',
  {
    variants: {
      intent: {
        primary: ['text-primary'],
        secondary: ['text-secondary'],
        accent: ['text-accent'],
        ai: ['text-ai/80'],
        success: ['text-accent/80'],
        error: ['text-error'],
        disabled: ['text-disabled'],
        warning: ['text-warning'],
        transparent: ['text-primary'],
        loading: ['text-primary'],
      },
    },
  },
);
type Props = {
  name: IconsName;
  className?: string;
  sizeAsNumber?: number;
  onClick?: () => void;
} & VariantProps<typeof icon>;
const Icon: FC<Props> = ({
  name,
  intent,
  size,
  className,
  sizeAsNumber,
  onClick,
}) => {
  const SvgIcon = SvgIcons[name];
  const iconClassName = sizeAsNumber
    ? iconWithoutSize({ intent })
    : icon({ intent, size });
  const width = !isNaN(sizeAsNumber ?? NaN) ? `${sizeAsNumber}px` : '24px';
  return (
    <div
      className={`inline-flex ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
    >
      <SvgIcon className={`${iconClassName}`} size={parseFloat(width)} />
    </div>
  );
};
export default Icon;
